<template>
<div>
    <div id="experience">
        <h2>{{ Experience }}</h2>
        <Work id="work" v-for="(companyInfo, companyIndex) in companies" :companyInfo="companyInfo" :key="`company - ${companyIndex}`" />
    </div>
    <div id="project">
        <h2>{{ Project }}</h2>
        <Project id="projects" v-for="(projectInfo, projectIndex) in projects" :projectInfo="projectInfo" :key="`project - ${projectIndex}`" />
    </div>
</div>
</template>

<script>
import Work from "./WorkDescription";
import Project from "./Project";
export default {
    name: "WhatIHaveDone",
    data() {
        return {
            Experience: "Experience",
            Project: "Projects",
            companies: this.companies,
            projects: this.projects
        };
    },
    components: {
        Work,
        Project
    },
    mounted() {
        this.setup();
    },
    methods: {
        setup() {
            // company has the following format:
            //   companyName: String
            //   position: String
            //   timeFrame: String
            //   dutiesAndResponsibilities: list of String
            //   skills: list of String
            //   location: String
            this.companies = [{
                    companyName: "Google",
                    position: "Software Engineer",
                    timeFrame: "Aug 2020 - Present",
                    dutiesAndResponsibilities: [
                        "Advertiser Platform Team",
                    ],
                    skills: [],
                    location: "Mountain View, CA"
                },
                {
                    companyName: "Flexport",
                    position: "Software Engineer Intern",
                    timeFrame: "Jan 2020 - Apr 2020",
                    dutiesAndResponsibilities: [
                        "Added metadata attribute to both API v2 and Purchase Order CSV schema which allow end users to store information on a resource that is not captured in a Flexport-defined field",
                        "Incorporated row type property into Purchase Order CSV schema to help customers and operators better differentiate information, such as headers and line items, they wish to store",
                        "Initiated an automatic pipeline for transferring purchase order information to booking",
                    ],
                    skills: ["Ruby on Rails", "React","GraphQL"],
                    location: "San Francisco, CA"
                },
                {
                    companyName: "Opendoor",
                    position: "Software Engineer Intern",
                    timeFrame: "Sep 2019 - Dec 2019",
                    dutiesAndResponsibilities: [
                        "Improved the delivery performance of landing page (eg. reduced load time by 60%) by employing client-side optimization",
                        "Created a Slack integration that facilitated communication between customer experience officers and mortgage consultants",
                        "Implemented Iterable work flows that deliver personalized and targeted email and SMS to end users"

                    ],
                    skills: ["Go", "React", "Ruby on Rails", "SQL"],
                    location: "San Francisco, CA"
                },
                {
                    companyName: "Google",
                    position: "Software Engineering Intern",
                    timeFrame: "Jun 2019 - Present",
                    dutiesAndResponsibilities: [
                        "Implemented a quota management system which allocates available API calls to each operation that pushes, pulls, and authenticates information from external engines such as Bing, Yahoo Japan and Baidu",
                        "Created real-time interactive dashboards that display quota usages and alerts the team when there is an unexpected high quota exceeded rate",
                        "Developed OAuth token and username/password  authenticator that enabled account migration and local/QA environment testing"
                    ],
                    skills: ["Java", "Python"],
                    location: "Kirkland, WA"
                },
                {
                    companyName: "Datadog",
                    position: "Software Engineer Intern",
                    timeFrame: "Apr 2019 - Jun 2019",
                    dutiesAndResponsibilities: [
                        "Implemented HTTP retry strategies that resolve  429 Too Many Requests errors in different web-based crawlers",
                        "Developed an integration for Dingtalk Chatbot to subscribe to real-time alert messages from Datadog using a Redis worker and RESTful API",
                        "Architected a web crawler to concurrently collect and parse timer, engagement, and dimension metrics from Akamai mPulse"
                    ],
                    skills: ["Python", "React"],
                    location: "New York City, NY"
                },
                {
                    companyName: "Oz Management",
                    position: "Front Office Application Development Intern",
                    timeFrame: "Jun 2018 – Sep 2018",
                    dutiesAndResponsibilities: [
                        "Built a global IPO/Follow-on/Acquisitions monitoring tool that displays performance history/forecast, profit & loss, and compliance status",
                        "Automated categorization process for Reports Portal which automatically routes email to its designated department or team",
                        "Implemented SuperCache, which reduced Bloomberg requests made by 15% and projected to save $25000 annually"
                    ],
                    skills: [
                        "JavaScript",
                        "Python",
                        "C#",
                        "Angular.js",
                        ".Net framework",
                        "Microsoft SQL Server"
                    ],
                    location: "New York City, NY"
                },
                {
                    companyName: "Webroot",
                    position: "Software Developer Intern",
                    timeFrame: "Nov 2017 – Jun 2018",
                    dutiesAndResponsibilities: [
                        "Implemented and deployed the server status dashboard for the Support team to streamline status modifications",
                        "Improved the delivery performance of multiple sites (eg. reduced load time by 20%) by employing client-side optimization",
                        "Developed the automatic bug reporting tool for Webroot SecureAnywhere - DNS Protection application, which reduced ticket resolution time by over 30%",
                        "Created a C# API that analyzes and classifies the security level of local input directories, files, and/or URLs"
                    ],
                    skills: ["JavaScript", "Node.js", "Python", "C#", "Vue.js", "MySQL"],
                    location: "San Diego, CA"
                },
            ];

            // projects has the following format:
            //   projectName: String
            //   timeFrame: String
            //   features: list of String
            //   skills: list of String
            this.projects = [{
                    projectName: "AI Related Games",
                    timeFrame: "Jan 2019 - Present",
                    features: [
                        "Trying to learn some AI related topics and do some projects in the process",
                        "Some of the games include 2048, Gomoku, Blackjack, and Sudoku"
                    ],
                    skills: ["Python", "React"]
                },
                {
                    projectName: "MemeMaster",
                    timeFrame: "Dec 2018",
                    features: [
                        "A meme creator web application built with vanilla javascript (No framework and no Boostrap)",
                        "Used tools such Google Chrome Aduits and WebPageTest to compare the performance of vanilla JS with framework such as Angular, React, and Vuejs "
                    ],
                    skills: ["JavaScript", "HTML", "CSS"]
                },
                {
                    projectName: "WaitNoMore",
                    timeFrame: "Apr 2018",
                    features: [
                        "Developed a web application that allows users to explore restaurants, know the waiting time of restaurants, join the current waitlist of the restaurant and make orders and payments ahead of time ",
                        "Displayed crowdedness of the restaurants on Google Map and restaurants menu",
                        "Provided users with real-time updates about their orders and integrated online payments "
                    ],
                    skills: ["React", "Node.js", "Express.js", "Firebase", "JavaScript"]
                },
                {
                    projectName: "CamerRoll",
                    timeFrame: "Jan 2018",
                    features: [
                        "Developed an Android app that allows instructors to take attendance by taking a picture of the class ",
                        "Automatically inform parent about students tardiness and absences through text and voice mail ",
                        "Implemented features allowing users to easily organize multiple sections, identify each student, and record the information into an attendance system "
                    ],
                    skills: ["Java", "Android Studio", "Microsoft Cognitive Service"]
                }
            ];
        }
    }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Catamaran|Martel+Sans");

h2 {
    font-size: 2em;
    font-weight: 600;
    margin-bottom: 15px;
    text-align: left;
    font-family: "Catamaran", sans-serif;
}

#experience {
    margin-bottom: 30px;
}
</style>
